export default "__VITE_ASSET__CfNyHCZS__"